import { render, staticRenderFns } from "./schema.vue?vue&type=template&id=8f750b5c"
import script from "./schema.vue?vue&type=script&lang=js"
export * from "./schema.vue?vue&type=script&lang=js"
import style0 from "./schema.vue?vue&type=style&index=0&id=8f750b5c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports